// Action types for the legacy Access Hub stores, not migrated to createAction.

export const CREATE_API_KEY = 'CREATE_API_KEY'
export const CREATE_API_KEY_FAILED = 'CREATE_API_KEY_FAILED'
export const CREATE_API_KEY_SUCCESS = 'CREATE_API_KEY_SUCCESS'
export const CREATE_APPS_DATASET = 'CREATE_APPS_DATASET'
export const CREATE_APPS_DATASET_FAILED = 'CREATE_APPS_DATASET_FAILED'
export const CREATE_APPS_DATASET_SUCCESS = 'CREATE_APPS_DATASET_SUCCESS'
export const CREATE_DATA_PRODUCT = 'CREATE_DATA_PRODUCT'
export const CREATE_DATA_PRODUCT_FAILED = 'CREATE_DATA_PRODUCT_FAILED'
export const CREATE_DATA_PRODUCT_SUCCESS = 'CREATE_DATA_PRODUCT_SUCCESS'
export const DELETE_APPS_DATASET = 'DELETE_APPS_DATASET'
export const DELETE_APPS_DATASET_FAILED = 'DELETE_APPS_DATASET_FAILED'
export const DELETE_APPS_DATASET_SUCCESS = 'DELETE_APPS_DATASET_SUCCESS'
export const DELETE_DATA_PRODUCT = 'DELETE_DATA_PRODUCT'
export const DELETE_DATA_PRODUCT_FAILED = 'DELETE_DATA_PRODUCT_FAILED'
export const DELETE_DATA_PRODUCT_KEY = 'DELETE_DATA_PRODUCT_KEY'
export const DELETE_DATA_PRODUCT_KEY_FAILED = 'DELETE_DATA_PRODUCT_KEY_FAILED'
export const DELETE_DATA_PRODUCT_KEY_SUCCESS = 'DELETE_DATA_PRODUCT_KEY_SUCCESS'
export const DELETE_DATA_PRODUCT_SUCCESS = 'DELETE_DATA_PRODUCT_SUCCESS'
export const EXPORT_INSIGHT_STUDIO = 'EXPORT_INSIGHT_STUDIO'
export const EXPORT_INSIGHT_STUDIO_FAILED = 'EXPORT_INSIGHT_STUDIO_FAILED'
export const EXPORT_INSIGHT_STUDIO_SUCCESS = 'EXPORT_INSIGHT_STUDIO_SUCCESS'
export const GET_APPS_DATASET_PREVIEW = 'GET_APPS_DATASET_PREVIEW'
export const GET_APPS_DATASET_PREVIEW_FAILED = 'GET_APPS_DATASET_PREVIEW_FAILED'
export const GET_APPS_DATASET_PREVIEW_SUCCESS =
  'GET_APPS_DATASET_PREVIEW_SUCCESS'
export const GET_APPS_ONTOLOGY = 'GET_APPS_ONTOLOGY'
export const GET_APPS_ONTOLOGY_FAILED = 'GET_APPS_ONTOLOGY_FAILED'
export const GET_APPS_ONTOLOGY_SUCCESS = 'GET_APPS_ONTOLOGY_SUCCESS'
export const GET_DATASET_FILTER_VARIABLES = 'GET_DATASET_FILTER_VARIABLES'
export const GET_DATASET_FILTER_VARIABLES_FAILED =
  'GET_DATASET_FILTER_VARIABLES_FAILED'
export const GET_DATASET_FILTER_VARIABLES_SUCCESS =
  'GET_DATASET_FILTER_VARIABLES_SUCCESS'
export const GET_DATASET_TRANSFORMATION = 'GET_DATASET_TRANSFORMATION'
export const GET_DATASET_TRANSFORMATION_FAILED =
  'GET_DATASET_TRANSFORMATION_FAILED'
export const GET_DATASET_TRANSFORMATION_SUCCESS =
  'GET_DATASET_TRANSFORMATION_SUCCESS'
export const GET_DATA_PRODUCTS = 'GET_DATA_PRODUCTS'
export const GET_DATA_PRODUCTS_FAILED = 'GET_DATA_PRODUCTS_FAILED'
export const GET_DATA_PRODUCTS_SUCCESS = 'GET_DATA_PRODUCTS_SUCCESS'
export const GET_ONE_DATA_PRODUCT = 'GET_ONE_DATA_PRODUCT'
export const GET_ONE_DATA_PRODUCT_FAILED = 'GET_ONE_DATA_PRODUCT_FAILED'
export const GET_ONE_DATA_PRODUCT_SUCCESS = 'GET_ONE_DATA_PRODUCT_SUCCESS'
export const GET_PATHS_SUCCESS = 'GET_PATHS_SUCCESS'
export const GET_RELATED_TABLES = 'GET_RELATED_TABLES'
export const GET_RELATED_TABLES_FAILED = 'GET_RELATED_TABLES_FAILED'
export const GET_RELATED_TABLES_SUCCESS = 'GET_RELATED_TABLES_SUCCESS'
export const POLL_JOB_RUN = 'POLL_JOB_RUN'
export const POLL_JOB_RUN_FAILED = 'POLL_JOB_RUN_FAILED'
export const POLL_JOB_RUN_SUCCESS = 'POLL_JOB_RUN_SUCCESS'
export const PUT_TABLE_FILTER_VARIABLES = 'PUT_TABLE_FILTER_VARIABLES'
export const PUT_TABLE_FILTER_VARIABLES_FAILED =
  'PUT_TABLE_FILTER_VARIABLES_FAILED'
export const PUT_TABLE_FILTER_VARIABLES_SUCCESS =
  'PUT_TABLE_FILTER_VARIABLES_SUCCESS'
export const START_JOB_RUN = 'START_JOB_RUN'
export const START_JOB_RUN_FAILED = 'START_JOB_RUN_FAILED'
export const START_JOB_RUN_SUCCESS = 'START_JOB_RUN_SUCCESS'
export const UPDATE_APPS_DATASET = 'UPDATE_APPS_DATASET'
export const UPDATE_APPS_DATASET_FAILED = 'UPDATE_APPS_DATASET_FAILED'
export const UPDATE_APPS_DATASET_SUCCESS = 'UPDATE_APPS_DATASET_SUCCESS'
export const UPDATE_DATA_PRODUCT = 'UPDATE_DATA_PRODUCT'
export const UPDATE_DATA_PRODUCT_FAILED = 'UPDATE_DATA_PRODUCT_FAILED'
export const UPDATE_DATA_PRODUCT_KEY = 'UPDATE_DATA_PRODUCT_KEY'
export const UPDATE_DATA_PRODUCT_KEY_FAILED = 'UPDATE_DATA_PRODUCT_KEY_FAILED'
export const UPDATE_DATA_PRODUCT_KEY_SUCCESS = 'UPDATE_DATA_PRODUCT_KEY_SUCCESS'
export const UPDATE_DATA_PRODUCT_SUCCESS = 'UPDATE_DATA_PRODUCT_SUCCESS'
export const UPDATE_ENDPOINT = 'UPDATE_ENDPOINT'
export const UPDATE_ENDPOINT_FAILED = 'UPDATE_ENDPOINT_FAILED'
export const UPDATE_ENDPOINT_SUCCESS = 'UPDATE_ENDPOINT_SUCCESS'
